export const FireIcon = require("../assets/Fire.svg").default
export const StepsIcon = require("../assets/Steps.svg").default
export const TestimonialsIcon = require("../assets/Testimonials.svg").default
export const UserCheckIcon = require("../assets/UserCheck.svg").default
export const SearchIcon = require("../assets/Search.svg").default
export const GlitterIcon = require("../assets/Glitter.svg").default
export const HandShakeIcon = require("../assets/HandShake.svg").default
export const ArcUpIcon = require("../assets/ArcUp.svg").default
export const ArcDownIcon = require("../assets/ArcDown.svg").default
export const LeftPurple = require("../assets/LeftPurple.svg").default
export const LeftWhite = require("../assets/LeftWhite.svg").default
export const CenterPurple = require("../assets/CenterPurple.svg").default
export const CenterWhite = require("../assets/CenterWhite.svg").default
export const RightPurple = require("../assets/RightPurple.svg").default
export const RightWhite = require("../assets/RightWhite.svg").default
export const BlockQuote = require("../assets/BlockQuote.svg").default